// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animated-line-container {
  position: relative;
  overflow: hidden;
  height: 20px;
  margin-left: -32px;
  margin-right: -32px;
}

.animated-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 300%;
  height: 100%;
  background: repeating-linear-gradient(
    -45deg,
    var(--primary-color),
    var(--primary-color) 10px,
    var(--card-background-color) 10px,
    var(--card-background-color) 20px
  );
  animation: move-line 80s linear infinite;
}

@keyframes move-line {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-50%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/base/animated-line.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;EACD,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".animated-line-container {\n  position: relative;\n  overflow: hidden;\n  height: 20px;\n  margin-left: -32px;\n  margin-right: -32px;\n}\n\n.animated-line {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 300%;\n  height: 100%;\n  background: repeating-linear-gradient(\n    -45deg,\n    var(--primary-color),\n    var(--primary-color) 10px,\n    var(--card-background-color) 10px,\n    var(--card-background-color) 20px\n  );\n  animation: move-line 80s linear infinite;\n}\n\n@keyframes move-line {\n  from {\n    transform: translateX(0%);\n  }\n  to {\n    transform: translateX(-50%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
